<template>
    <span class="badge text-bg-secondary pointer-cursor my-1">
        {{ contact.name + " " + contact.contact }}
        <font-awesome-icon :icon="['fas', 'fa-xmark']" size="l" @click="remove" />
    </span>
    <br>
</template>

<script>
export default {
    props: ['contact'],
    methods: {
        remove() {
            this.$emit("remove", this.contact.id);
        }
    }
}
</script>